import { useCallback, useState } from "react";
import ReactDOM from "react-dom";
import Notification from "./notification";
import { v4 as uuidv4 } from 'uuid';



const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(
    (message, variant) => {
      const id = uuidv4();
      setToasts((prevToasts) => {
        if (prevToasts.length > 5) {
          const newPrevToasts = prevToasts.slice(1);
          return [...newPrevToasts, { id, message, variant }];
        }
        return [...prevToasts, { id, message, variant }];
      });
      setTimeout(() => {
        removeToast(id);
      }, 3000);
    },
    []
  );

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const Toast = () => {
    return ReactDOM.createPortal(
      <div className="toast-container">
        {toasts.map((toast, index) => (
          <Notification
            key={toast.id}
            message={toast.message}
            variant={toast.variant}
            onClose={() => removeToast(toast.id)}
            showed={index !== toasts.length - 1} // Show only the last toast
          />
        ))}
      </div>,
      document.body
    );
  };

  return { addToast, Toast };
};

export default useToast;